// --------------------------------------------------------------
// Created On: 2025-10-09
// Author: Zachary Thomas
//
// Last Modified: 2026-10-20
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./AddResourceButton.module.scss";

// Extra wide button with border for adding resources in a modal or on a page.
export default function AddResourceButton(props: Props): Component {
  return (
    <div className={styles.body} data-test="add-resource-button">
      <button
        data-test="add-resource-button"
        className={`${styles.createButton} btn btn-success m-3`}
        disabled={props.disabled}
        type="button"
        onClick={() => props.onAddResource()}
      >
        {props.text}
      </button>
    </div>
  );
}

interface Props {
  text: string;
  disabled?: boolean;
  onAddResource: () => void;
}
